class CharacterLimit {
    el: HTMLInputElement | HTMLTextAreaElement;
    limit: number = 1000;
    suffix: string;
    counter: HTMLElement;

    constructor( sourceElement: HTMLInputElement | HTMLTextAreaElement ) {
        this.el = sourceElement;

        if ( this.el.dataset.limit ) {
            this.limit = parseInt( this.el.dataset.limit );
        }

        this.suffix = this.el.dataset.characterLimitSuffix || '';

        this.counter = document.createElement( 'small' );
        this.counter.className = 'twc__character--limit-counter';

        this.setCounter();

        if ( this.el.parentElement ) {
            this.el.parentElement.style[ 'position' ] = 'relative';
            this.el.parentElement.style[ 'padding-bottom' ] = '20px';
            this.el.parentElement.appendChild( this.counter );
        }

        this.el.addEventListener( 'input', this.change.bind( this ) );

        if ( this.el.value.length >= this.limit ) {
            this.el.classList.add( 'twc__character--limit-reached' );
            this.counter.classList.add( 'twc__character--limit-reached' );
        }

        this.el.classList.add( 'twc__character--limit-initialised' );
    }

    update(): void {
        if ( this.el.value.length >= this.limit ) {
            this.el.classList.add( 'twc__character--limit-reached' );
            this.counter.classList.add( 'twc__character--limit-reached' );
            this.el.value = this.el.value.substring( 0, this.limit );
        } else {
            this.el.classList.remove( 'twc__character--limit-reached' );
            this.counter.classList.remove( 'twc__character--limit-reached' );
        }
        this.setCounter();
    }

    change(): void {
        this.update();
    }

    setCounter(): void {
        this.counter.innerText = this.el.value.length + '/' + this.limit + ' ' + this.suffix;
    }

    static init( parent: HTMLElement | Document ): void {
        const container = parent || document;
        const elements = container.getElementsByClassName( 'twc__character--limit' ) as HTMLCollectionOf<HTMLInputElement | HTMLTextAreaElement>;

        for ( let i = 0; i < elements.length; i++ ) {
            if ( elements[ i ].classList.contains( 'twc__character--limit-initialised' ) ) {
                continue;
            }
            new CharacterLimit( elements[ i ] );
        }
    }
}

export default function initCharacterLimit() {
    CharacterLimit.init( document );

    document.addEventListener( 'twc:newcontentloaded', ( event: CustomEvent ) => {
        const detail = event.detail || {};
        CharacterLimit.init( detail.container || document );
    } );
}
